/* eslint-disable jsx-a11y/anchor-is-valid */
import { useTranslation } from '@pancakeswap/localization'
import { Flex, Link as ExternalLink, OpenNewIcon } from '@pancakeswap/uikit'
import Link from 'next/link'
import { useRouter } from 'next/router'
import styled from 'styled-components'

const StyledNav = styled.nav`
  margin-bottom: 0px;
  justify-content: center;
  text-align: center;
  display: flex;
  overflow: hidden;
  flex-direction: row;
  width: 100%;
  box-sizing: border-box;
  margin-left: auto;
  margin-right: auto;
  ${({ theme }) => theme.mediaQueries.sm} {
    flex-direction: row;
    width: 550px;
  }
  p {
    flex-grow: 1;
    padding-top: 12px;
    padding-bottom: 12px;

    color: ${({ theme }) => theme.colors.text};
    font-weight: bold;
    font-size: 18px;
    line-height: 16px;
    text-align: center;
    height: 50px;
    display: inline-block;
    padding: 10px 0px;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
  }
`
const defaultStyle = {

}
const styleActive = {
    textDecoration: "underline"
}
const Wrapper = styled.div`
  width:100%;
  max-width: 450px;
  height:auto;
  margin-top: 3rem;
  @media screen and (max-width: 600px) {
    padding: 0 20px;
  }
`
const CsExternalLink = styled(ExternalLink)`
    &:hover {
      text-decoration: none;
    }
`

const CsStyledNav = styled(StyledNav)`
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 24px;
  margin-bottom: 24px;
  @media screen and (max-width:600px) {
      gap: 12px;
  }
`

const CustomNavLink = styled.p<{isDisabled?:boolean}>`
    color: ${({ theme }) => theme.colors.white} !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    padding-bottom: 20px !important;
    opacity: ${({ isDisabled }) => isDisabled ? "0.8" : 1} !important;
    cursor:pointer;
`
const WrapLink = styled(Flex)`
  @media screen and (max-width: 1336px){
    padding: 10px 0px;
  }
`
const Strong = styled.strong`
    font-size: 20px;
    @media screen and (max-width: 600px){
      font-size: 16px;
    }
`
const WrapAppBody = styled.div`
  @media only screen and (max-width: 600px) {
    margin-left: 0px;
    margin-right: 0px;
    padding: 0px;
  }
`
const getActiveIndex = (pathname: string): number => {
    if (
        pathname.includes('/liquidity') || pathname.includes('/add') || pathname.includes('/find') || pathname.includes('/remove')
    ) {
        return 1
    }
    return 0
}

const Nav = () => {
    const { pathname } = useRouter()
    const { t } = useTranslation()
    const activeIndex = getActiveIndex(pathname)

    return (
        <Wrapper>
            <WrapAppBody>
                <CsStyledNav>
                    <WrapLink style={activeIndex === 0 ? styleActive : defaultStyle}>
                        <Link href="/swap" passHref>
                            <CustomNavLink style={activeIndex === 0 ? styleActive : defaultStyle}>
                                <Strong>
                                    {t('Swap')}
                                </Strong>
                            </CustomNavLink>
                        </Link>
                    </WrapLink>
                    <WrapLink style={activeIndex === 1 ? styleActive : defaultStyle}>
                        <Link href="/liquidity" passHref>
                            <CustomNavLink style={activeIndex === 1 ? styleActive : defaultStyle}>
                                <Strong>
                                    {t('Liquidity')}
                                </Strong>
                            </CustomNavLink>
                        </Link>
                    </WrapLink>
                    <WrapLink style={defaultStyle}>
                        <CsExternalLink href="https://bridge.base.org/" external>
                            <CustomNavLink style={defaultStyle}>
                                <Strong>
                                    {t('Bridge')}
                                </Strong>
                                <OpenNewIcon color='white'/>
                            </CustomNavLink>
                        </CsExternalLink>
                    </WrapLink>
                    <WrapLink style={defaultStyle}>
                        <Link href="#" passHref>
                            <CustomNavLink style={defaultStyle} isDisabled>
                                {t('Perpetual')}
                            </CustomNavLink>
                        </Link>
                    </WrapLink>
                </CsStyledNav>
            </WrapAppBody>
        </Wrapper>
    )
}

export default Nav
